import { useState, useCallback } from 'react';
import { reject } from 'lodash/fp';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';

/**
 * A hook to manage (list, add, remove) the event group visibility records
 */
export function useVisibilityGroups({ eventId, initialState }) {
  const [visibilityGroups, setVisibilityGroups] = useState(initialState);

  const createVisibilityGroup = useCallback(
    group => {
      request
        .postJSON(routes.IN_PERSON_TRAINING.EVENT_VISIBILITY_GROUPS(eventId), {
          group_id: group.id,
        })
        .then(visibilityGroup => {
          setVisibilityGroups(contents => [...contents, visibilityGroup]);
        });
    },
    [eventId],
  );

  const removeVisibilityGroup = useCallback(
    visibilityGroup => {
      request
        .delete(
          routes.IN_PERSON_TRAINING.EVENT_VISIBILITY_GROUP(
            eventId,
            visibilityGroup.id,
          ),
        )
        .then(() => {
          setVisibilityGroups(reject({ id: visibilityGroup.id }));
        });
    },
    [eventId],
  );

  return {
    data: visibilityGroups,
    remove: removeVisibilityGroup,
    create: createVisibilityGroup,
  };
}
